import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import ReactDOM from "react-dom";
import HISTORY from "./../history.json";
import Graph from "./Graph.jsx";
import { Cookies } from "react-cookie";
import timeTotal from "./../timetotal.json";
import { postSearchActivity } from "./api";
import { useCookies } from "react-cookie";
import ExcelDownloadButton from "./ExcelDownloadButton";
import SearchTable from "./SearchTable";
const ExcelTableSearch = (search) => {
  const [itemOffset, setItemOffset] = useState(0);
  const [cookies, setCookies, removeCookies] = useCookies(["emailAddress"]);
  // console.log('is',search)
  
  const [descrBool, setDescrBool] = useState(
    search.type
      ? search.type.includes("deal") && search.type.length == 1
        ? true
        : false
      : ""
  );
  
  const [searchString, setSearchString] = useState(
    localStorage.getItem("search")
      ? () => {
          postSearchActivity(
            cookies.emailAddress,
            localStorage.getItem("search")
          );
          return localStorage.getItem("search");
        }
      : () => {
          return search.search;
        }
  );
  let lt = 150;
  let caseBool=search.case
  const [modalProjectId, setModalProjectId] = useState("");
  const [forcedPage, setForcedPage] = useState(null);
  const [modalMapper, setModalMapper] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const isFirstPage = currentPage === 0;
  const [sorttype, setSorttype] = useState("desc");
  const [sorttype1, setSorttype1] = useState("desc1");
  let [allResults, setAllResults] = useState([]); // Store all the searched results
  let output = [];
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(pageSize);
  const [keyDisplay, setKeyDisplay] = useState(Object.keys(HISTORY));
  const [resultCopy, setResultCopy] = useState([]);
  const [filter, setFilter] = useState("All Verticals  ");

  const [projectJSON, setProjectJSON] = useState();
  const [taskJSON, setTaskJSON] = useState();
  const isLastPage =
    currentPage === Math.ceil(keyDisplay.length / pageSize) - 1;
  let del;
  let graphData = [];
  const [ms, setMs] = useState(new Set());
  let ver = search.ver||[];
  useEffect(() => {
    if (searchString.trim() != "") {
      fetchJsonData();
    } else {
      setSearchResults([]);
      setKeyDisplay(sortMe(HISTORY));
    }
  }, [descrBool]);

  let filterSelect = (e) => {
    setLoading(true);
    let tempArray = [];
    for (let it of allResults) {
      if (
        e.target.value.trim() != "Unlisted" &&
        e.target.value.trim() != "Select"
      ) {
        if (it.Vertical == e.target.value) {
          tempArray.push(it);
        }
      } else if (e.target.value.trim() == "Unlisted") {
        if (!it.Vertical) {
          tempArray.push(it);
        }
      } else {
        tempArray = allResults;
        // console.log("Select")
      }
    }
    setLoading(false);
    setResultCopy(tempArray);
    const root=ReactDOM.createRoot(document.getElementById('tbl'));
    root.render(<SearchTable result={tempArray} modalMapper={modalMapper} searchString={searchString} allResults={allResults}/>)

  };
  const projectNameBasedSearch = async (taskJSON, projectJSON) => {
    let modalOptions = {};
    let filteredResults = [];
    for (let page = 1; page <= Math.ceil(projectJSON.length); page++) {
      const startIndex = (page - 1) * pageSize;
      const endIndex = page * pageSize;
      const pageData = projectJSON.slice(startIndex, endIndex);
      const pageResults = pageData.filter((item) => {
        const projectName = item.ProjectName;
        let lowerCaseSearchString=''
        let searchRegex=''
        if(caseBool){
        lowerCaseSearchString =
          typeof searchString === "string"
            ? searchString.trim()
            : "";
            searchRegex = new RegExp(`\\b${lowerCaseSearchString}\\b`);
          }
        else{
          lowerCaseSearchString =
          typeof searchString === "string"
            ? searchString.trim().toLowerCase()
            : "";
            searchRegex = new RegExp(`\\b${lowerCaseSearchString}\\b`, "i");
        }
        return typeof projectName === "string" && searchRegex.test(projectName);
      });
      filteredResults.push(...pageResults);
    }
    let out = {};
    for (let it of filteredResults) {
      out[it.ProjectId] = it;
      out[it.ProjectId] = {
        ...it,
        TaskDescription: "",
        TaskName: "",
        HoursTracked: 0,
      };
    }
    for (let it of Object.keys(out)) {
      if (taskJSON[it]) {
        for (let j of taskJSON[it]) {
          if (j.TaskName) {
            out[j.ProjectId].TaskName += `(#)${j.TaskName}`;
          }
          if (j.TaskDescription) {
            out[j.ProjectId].TaskDescription += `(#)${j.TaskDescription}`;
          }
          if (j.HoursTracked) {
            let time = j.HoursTracked || 0;
            out[j.ProjectId].HoursTracked += time;
          }
          if (modalOptions[j.ProjectId]) {
            modalOptions[j.ProjectId].push(j);
          } else {
            modalOptions[j.ProjectId] = [j];
          }
        }
      }
    }
    // console.log('📃',modalOptions)
    setModalMapper(modalOptions);
    setAllResults(Object.values(out));
    setResultCopy(Object.values(out));
    // setAllResults(out2)
    setLoading(false);
    setCurrentPage(0);
  };
  
  const descriptionBasedSearch = (taskJSON, projectJSON) => {
    const filteredResults = [];
    let mySet = new Set();
    const pageSize = 100;
    const totalPages = Math.ceil(Object.keys(taskJSON).length / pageSize);
    // console.log("no", totalPages);
    for (let page = 1; page <= totalPages; page++) {
      const startIndex = (page - 1) * pageSize;
      const endIndex = page * pageSize;
      const pageData = Object.values(taskJSON).slice(startIndex, endIndex);
      // console.log("i am ", pageData);
      const pageResults = pageData.filter((element) => {
        element.forEach((item) => {
          // console.log("i ", item);
          const taskName = item.TaskName || "";
          const taskDescription = item.TaskDescription || "";
          // console.log(taskName)
          // Convert searchString to a string and then use trim()
          let lowerCaseSearchString='';
          let searchRegex='';
          if(caseBool){
            lowerCaseSearchString =
            typeof searchString === "string"
              ? searchString.trim() 
              : "";
              searchRegex =new RegExp(`\\b${lowerCaseSearchString}\\b`);
            }
          else{
            lowerCaseSearchString =
            typeof searchString === "string"
              ? searchString.trim().toLowerCase()
              : "";
              searchRegex = new RegExp(`\\b${lowerCaseSearchString}\\b`, "i");
            
          }
          
          let ans =
            (typeof taskName === "string" && searchRegex.test(taskName)) ||
            (typeof taskDescription === "string" &&
              searchRegex.test(taskDescription)) ||
            (typeof Projec === "string" && searchRegex.test(taskDescription));
          if (ans == true) filteredResults.push(item);
        });
      });
      // filteredResults.push(...pageResults);
    }
    // console.log("hm ", filteredResults);
    let out2 = [];
    // setAllResults(filteredResults);
    localStorage.setItem("search", "");
    output = filteredResults;
    let taskrespforprojectjson = {};
    for (let it of filteredResults) {
      taskrespforprojectjson[it.ProjectId]
        ? (taskrespforprojectjson[it.ProjectId] = [
            ...taskrespforprojectjson[it.ProjectId],
            it,
          ])
        : (taskrespforprojectjson[it.ProjectId] = [it]);
      mySet.add(it.ProjectId);
    }
    for (let it of projectJSON) {
      if (mySet.has(it.ProjectId)) {
        out2 = [...out2, it];
      }
    }

    let main_response = [];
    for (let it of out2) {
      let descr = "";
      let name = "";
      let project = "";
      let totaltime = 0;
      for (let itt of taskrespforprojectjson[it.ProjectId]) {
        descr
          ? (descr += itt.TaskDescription ? `(#) ` + itt.TaskDescription : "")
          : (descr = itt.TaskDescription);
        name
          ? (name += itt.TaskName ? " and " + itt.TaskName : "")
          : (name = itt.TaskName);
        totaltime += itt.HoursTracked ? itt.HoursTracked : 0;
      }
      main_response.push({
        ProjectId: it.ProjectId,
        ProjectName: it.ProjectName,
        TaskDescription: descr,
        TaskName: name,
        ProjectOwner: it.ProjectOwner,
        HoursTracked: totaltime,
        Vertical: it.Vertical,
        ActualCompletedDate:it.ActualCompletedDate
      });
      setMs(ms.add(it.Vertical));
    }
    // console.log('💣',taskrespforprojectjson)
    // console.log(taskrespforprojectjson);
    setModalMapper(taskrespforprojectjson);
    // console.log('Modal✔️',taskrespforprojectjson)
    setAllResults(main_response);
    setResultCopy(main_response);
    // setAllResults(out2)
    setLoading(false);
    setCurrentPage(0);
  };
  const fetchJsonData = async () => {
    setLoading(true);

    // console.log("I am inn to search for ", searchString);
    try {
      const response = await fetch("./output_file.json");
      const response2 = await fetch("./output_fil.json");
      const jsonData = await response.json();
      const jsonData2 = await response2.json();
      let temp = [];
      if (ver.length > 0 && !ver.includes('All Verticals')) {
        for (let it in jsonData2) {
          if (ver.includes(jsonData2[it].Vertical)) {
            temp.push(jsonData2[it]);
          }
          // console.log('running...')
        }
        // jsonData2=temp
      }
      // console.log("jsonData2 is ", jsonData2,temp);
      setProjectJSON(jsonData2);
      setTaskJSON(jsonData);

      if (descrBool) {
        console.log("Project Based Search", jsonData, jsonData2);
        if(ver.length>0 && !ver.includes('All Verticals')){
          projectNameBasedSearch(jsonData, temp);
        }
        else
        projectNameBasedSearch(jsonData, jsonData2);
      } else {
        // console.log("Descr Based Search");
        if(ver.length>0 && !ver.includes('All Verticals')){
          descriptionBasedSearch(jsonData, temp);
        }
        else
        descriptionBasedSearch(jsonData, jsonData2);
      }
    } catch (error) {
      console.error("Error fetching JSON data:", error);
      setLoading(false);
    }
  };
  const handleTableRowClick = async (search) => {
    localStorage.setItem("search", search);
    window.location.reload(true);
  };
  function sortMe(list) {
    if(document.getElementById("desc1"))
    document.getElementById("desc1").className = "hidden";
    if(document.getElementById("asc1"))
    document.getElementById("asc1").className = "hidden";
    if(document.getElementById("both1"))
    document.getElementById("both1").className = "visible";
    if (sorttype == "desc") {
      if(document.getElementById("desc"))
      document.getElementById("desc").className = "visible";
      if(document.getElementById("asc"))
      document.getElementById("asc").className = "hidden";
      if(document.getElementById("both"))
      document.getElementById("both").className = "hidden";
      var keysSorted = Object.keys(list).sort(function (a, b) {
        return list[b] - list[a];
      });
      setSorttype("asc");
    } else {
      if(document.getElementById("desc"))document.getElementById("desc").className = "hidden";
      if(document.getElementById("asc"))document.getElementById("asc").className = "visible";
      if(document.getElementById("both"))document.getElementById("both").className = "hidden";
      keysSorted = Object.keys(list).sort(function (a, b) {
        return list[a] - list[b];
      });
      setSorttype("desc");
    }
    setStart(0);
    setEnd(pageSize);
    setForcedPage(0);
    return keysSorted;
  }
  function sortMe1(list) {
    if(document.getElementById("desc"))document.getElementById("desc").className = "hidden";
    if(document.getElementById("asc"))document.getElementById("asc").className = "hidden";
    if(document.getElementById("both"))document.getElementById("both").className = "visible";

    if (sorttype1 == "desc1") {
      if(document.getElementById("desc1"))document.getElementById("desc1").className = "visible";
      if(document.getElementById("asc1"))document.getElementById("asc1").className = "hidden";
      if(document.getElementById("both1"))document.getElementById("both1").className = "hidden";
      var keysSorted = Object.keys(list).sort(function (a, b) {
        return list[b] - list[a];
      });
      setSorttype1("asc1");
    } else {
      if(document.getElementById("desc1"))document.getElementById("desc1").className = "hidden";
      if(document.getElementById("asc1"))document.getElementById("asc1").className = "visible";
      if(document.getElementById("both1"))document.getElementById("both1").className = "hidden";
      keysSorted = Object.keys(list).sort(function (a, b) {
        return list[a] - list[b];
      });
      setSorttype1("desc1");
    }
    setStart(0);
    setEnd(pageSize);
    setForcedPage(0);
    return keysSorted;
  }
  function plotGraph(obj) {
    let mappedArray = [];
    // console.log(obj);
    let i = 0;
    for (let it = start; it < end; it++) {
      // console.log(obj[it]);
      mappedArray.push({
        x: i * 4,
        y: HISTORY[obj[it]],
        label: Object.keys(HISTORY)[it],
        label: obj[it],
      });
      i = 1 + i;
    }
    graphData = mappedArray;
  }
  const miniFunc2 = (item, e) => {
    e.preventDefault();
    if (document.getElementById("modal"))
      document.getElementById("modal").className = "relative z-10";
    setModalProjectId(item.ProjectId);
  };
  
  
  const renderJsonResults = () => {
    
    let elt=<div></div>
      elt= (
        <div className=" grid grid-cols-1 grid-flow-row-dense grid-rows-2 justify-items-center md:grid-rows-1 md:justify-items-start md:w-[90%] md:grid-cols-5 justify-center">
          <div className="col-span-1 mb-4 md:col-span-3 mt-0 flex flex-col scale-95 md:pl-0">
            <div id="alltools" className="">
              <table className="table-fixed w-[100%] lg:w-[60%] md:table-fixed">
                <caption className="text-slate-900 pb-1">
                  Showing{" "}
                  <b>
                    {end > keyDisplay.length
                      ? `${start + 1}-${keyDisplay.length}`
                      : `${start + 1}-${end}`}
                  </b>{" "}
                  of <b>{Object.keys(HISTORY).length}</b> results
                </caption>
                <thead className="font-bold bg-zinc-200">
                  <tr>
                    <td className="w-1/5 text-center">Srl. No.</td>
                    <td className="w-2/5 pl-3">Tool</td>
                    <td
                      className="w-1/5 cursor-pointer px-2 py-7"
                      onClick={() => {
                        setKeyDisplay(sortMe(HISTORY));
                      }}
                    >
                      <div className="flex gap-1 w-[100%] border-l-0 border-b-0">
                        <div className="text-center">Count</div>
                        <div id="desc" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                            />
                          </svg>
                        </div>
                        <div id="asc" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
                            />
                          </svg>
                        </div>
                        <div id="both" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                    <td
                      className="w-1/5 cursor-pointer p-2"
                      onClick={() => {
                        setKeyDisplay(sortMe1(timeTotal));
                      }}
                    >
                      <div className="flex gap-1 w-[100%] border-l-0 border-b-0 pl-3">
                        <div className="flex flex-col">
                          <div>Time</div>
                          <div className="text-xs font-semibold text-center">
                            (hr)
                          </div>
                        </div>
                        <div id="desc1" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                            />
                          </svg>
                        </div>
                        <div id="asc1" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M12 4.5v15m0 0l6.75-6.75M12 19.5l-6.75-6.75"
                            />
                          </svg>
                        </div>
                        <div id="both1" className="hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-6"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                            />
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {plotGraph(keyDisplay)}
                  {keyDisplay.slice(start, end).map((it, index) => (
                    <tr>
                      <td className="text-center table-cell py-2">
                        {index + 1 + start}
                      </td>
                      <td
                        className="table-cell pl-3 cursor-pointer hover:font-semibold active:font-bold text-blue-700"
                        onClick={async () => {
                          await handleTableRowClick(it);
                        }}
                      >
                        {it.slice(0, 1).toUpperCase() + it.slice(1)}
                      </td>
                      <td className="text-center table-cell">{HISTORY[it]}</td>
                      <td className="text-center table-cell">
                        {timeTotal[it]}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <td className=""></td>
                  <td colSpan={2}>
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={(e) => {
                        setStart(e.selected * pageSize);
                        setEnd(pageSize * (e.selected + 1));
                        setForcedPage(e.selected);
                        setCurrentPage(e.selected);
                      }}
                      forcePage={forcedPage}
                      containerClassName="cntn"
                      pageClassName="pag"
                      nextClassName={isLastPage ? "disabled" : "nxt"}
                      breakClassName="brk"
                      previousClassName={isFirstPage ? "disabled" : "prv"}
                      activeClassName="actv"
                      disabledClassName="disabled"
                      pageRangeDisplayed={5}
                      pageCount={Object.keys(HISTORY).length / pageSize}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                    />
                  </td>
                  <td></td>
                </tfoot>
              </table>
            </div>

            <hr className="bg-zinc-800 md:hidden mt-5" />
          </div>
          <div
            id="plot"
            className="mt-0 col-span-2 w-screen border-solid md:min-w-min md:max-w-[100%] md:mt-20"
          >
            <Graph data={graphData} />
          </div>
        </div>
      );
    
    
     
    return elt;
  };
  
  return (
    <div>
      <div className="flex justify-center" >
        {searchString.trim() !== "" &&
          (loading ? (
            <div style={{ textAlign: "center", marginTop: "200px" }}>
              <div style={{ marginLeft: "40px", marginBottom: "20px" }}>
                <svg
                  aria-hidden="true"
                  class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </div>
              <div>Fetching Results...</div>
            </div>
          ) : allResults.length ? (
            <div className="mt-8" id="onsbmt">
              <div className=" w-[100%] relative h-[40px]">
                {cookies.emailAddress == "ashish.aggarwal@leadsquared.com" ||
                cookies.emailAddress == "mehul.agarwal@leadsquared.com" ||
                cookies.emailAddress == "deepak@leadsquared.com " ? (
                  <ExcelDownloadButton
                    className=""
                    data={resultCopy}
                    search={searchString}
                    vertical={filter}
                  />
                ) : (
                  ""
                )}
                
                <div className="flex flex-row gap-10">
                
                  <select
                    name="vertical"
                    className="border-2 border-gray-500 text-white rounded-sm ml-3 p-1 w-48 bg-gray-800 focus:bg-slate-200 focus:border-gray-300 focus:text-black focus:border-1 hover:bg-slate-200 hover:border-slate-300 hover:text-black hover:border-1 focus:outline-none"
                    id="vertical"
                    onChange={(e) => {
                      setFilter(e.target.value);
                      filterSelect(e);
                    }}
                  >
                    <option value="Select ">Select Vertical</option>
                    {Array.from(ms)
                      .sort()
                      .map((it) => (
                        <option className="bg-white text-black" value={it}>
                          {it ? it : "Unlisted"}
                        </option>
                      ))}
                  </select>
                  <div className="flex flex-row gap-8 mt-2 font-sans text-md text-zinc-500">
                    <div>
                      <input
                        defaultChecked={descrBool}
                        type="checkbox"
                        id="projectName"
                        value="projectName"
                        onChange={() => {
                          setDescrBool(!descrBool);
                        }}
                      />
                      <label htmlFor="projectName" className="ml-2">
                        Project Name based
                      </label>
                    </div>
                    <div>
                      <input
                        defaultChecked={!descrBool}
                        type="checkbox"
                        id="projectName"
                        value="projectName"
                        onChange={() => {
                          setDescrBool(!descrBool);
                        }}
                      />
                      <label htmlFor="projectName" className="ml-2">
                        Description based
                      </label>
                    </div>
                   
                    {
                      ver.length>0?<div className="w-fit h-fit py-1 px-2 rounded-md bg-red-800 text-white text-sm cursor-pointer"
                      onMouseDownCapture={() => {
                        document.getElementById("filters")
                          .className ==
                        "ml-2 absolute bg-transparent z-50 w-80"
                          ? (document.getElementById(
                              "filters"
                            ).className = "hidden")
                          : (document.getElementById(
                              "filters"
                            ).className =
                              "ml-2 absolute bg-transparent z-50 w-80");
                      }}
                      >Advanced Search Applied</div>:""
                    }
                   
                  </div>
                </div>
              </div>
              <div id="tbl">
              <SearchTable result={resultCopy} modalMapper={modalMapper} searchString={searchString} allResults={allResults}/>
              </div>
            </div>
          ) : (
            <div id="onsbmt" className="relative w-screen h-[80vh]">
              
              <div className="left-0 top-10 absolute">
                <div className="flex flex-col">
                  <div className="flex flex-row gap-10">
                    <select
                      name="vertical"
                      className="border-2 border-gray-500 text-white rounded-sm ml-3 p-1 w-48 bg-gray-800 focus:bg-slate-200 focus:border-gray-300 focus:text-black focus:border-1 hover:bg-slate-200 hover:border-slate-300 hover:text-black hover:border-1 focus:outline-none"
                      id="vertical"
                      onChange={(e) => {
                        setFilter(e.target.value);
                        filterSelect(e);
                      }}
                    >
                      <option value="Select ">Select Vertical</option>
                      {Array.from(ms)
                        .sort()
                        .map((it) => (
                          <option className="bg-white text-black" value={it}>
                            {it ? it : "Unlisted"}
                          </option>
                        ))}
                    </select>
                    <div className="flex flex-row gap-8 mt-2 font-sans text-md text-zinc-500">
                      <div>
                        <input
                          defaultChecked={descrBool}
                          type="checkbox"
                          id="projectName"
                          value="projectName"
                          onChange={() => {
                            setDescrBool(!descrBool);
                          }}
                        />
                        <label htmlFor="projectName" className="ml-2">
                          Project Name based
                        </label>
                      </div>
                      <div>
                        <input
                          defaultChecked={!descrBool}
                          type="checkbox"
                          id="projectName"
                          value="projectName"
                          onChange={() => {
                            setDescrBool(!descrBool);
                          }}
                        />
                        <label htmlFor="projectName" className="ml-2">
                          Description based
                        </label>
                      </div>
                    </div>
                  </div>
                  <p className="text-center w-screen pt-10 font-semibold">
                    No Results Found
                  </p>
                </div>
              </div>
            </div>
          ))}

        {searchString == "" ? renderJsonResults() : ""}
      </div>
    </div>
  );
};

export default ExcelTableSearch;
